<template>
  <div>
    <template v-if="disabled">
      {{ data }}
    </template>
    <!-- class="demo-inline-spacing" class="form-control"

      :placeholder="$t('_components.placeholder.select')+label"-->
    <a-range-picker
      v-else
      v-model="data"
      size="large"
      :disabled="disabled"
      :show-time="{
        hideDisabledOptions: true,
        defaultValue: [
          moment('00:00:00', 'HH:mm:ss'),
          moment('23:59:59', 'HH:mm:ss'),
        ],
      }"
      format="DD MMM YYYY HH:mm:ss"
      :disabled-date="disabledDate"
      @change="dateChange"
    />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  components: {},
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: null,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: [],
      // defaultValue:
      disabledStartDate: moment(this.option.disabledStartDate),
      disabledEndDate: moment(this.option.disabledEndDate),
    }
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        console.log(e, '========range   eeee')
        const data = e.map((item) => this.formatDate(item))
        this.$emit('input', data)
      },
    },
    value: {
      handler(e) {
        // 用于清空选择器
        if (!e) {
          this.data = []
        }
      },
      deep: true,
    },
  },
  methods: {
    moment,
    dateChange(dates, dateStrings) {
      console.log(dates, dateStrings)

      this.data = dateStrings
    },
    formatDate(e) {
      console.log(e)
      if (e) {
        return moment(e).format('YYYY-MM-DD HH:mm:ss ')
      }
      return ''
    },
    disabledDate(current) {
      const newDate = moment(current).format('YYYY-MM-DD')
      if (!this.option.disabledStartDate || !this.option.disabledEndDate) {
        return ''
      }
      return (
        moment(newDate).isBefore(
          moment(this.disabledStartDate).format('YYYY-MM-DD')
        ) ||
        moment(newDate).isAfter(
          moment(this.disabledEndDate).format('YYYY-MM-DD')
        )
      )
    },
  },
}
</script>

<style lang="scss">
.form-control {
  height: 100%;
  width: 100%;
  margin: 0;
}
</style>
